import React, { useState, useEffect } from "react";
import PhoneInput from "../../../common/components/PhoneInput";
import axios from "axios";
import { registerUserByAdmin } from "../../services/adminUserService";

const TIMEZONES = [
  "Asia/Kolkata",
  "Asia/Dubai",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Europe/London",
  "Europe/Paris",
  "America/New_York",
  "America/Chicago",
  "America/Los_Angeles",
  "Australia/Sydney",
];

const INIT = { name: "", email: "", mobile_number: "", country_code: "+91", whatsapp_enabled: false, time_zone: "Asia/Kolkata" };

const RegisterUserModal = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState(INIT);
  const [countryCodes, setCountryCodes] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BASE_URL}/public/country-codes`)
      .then(res => setCountryCodes(res.data?.data || []))
      .catch(() => {});
  }, []);

  const emailValid = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => {
      const updated = { ...prev, [name]: type === "checkbox" ? checked : value };
      if (name === "mobile_number" && !value) updated.whatsapp_enabled = false;
      return updated;
    });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return setError("Full name is required.");
    if (!emailValid(form.email)) return setError("Enter a valid email address.");
    setLoading(true);
    try {
      await registerUserByAdmin({
        name: form.name.trim(),
        email: form.email.trim(),
        country_code: form.mobile_number.trim() ? form.country_code : undefined,
        mobile_number: form.mobile_number.trim() || undefined,
        whatsapp_enabled: form.whatsapp_enabled,
        time_zone: form.time_zone,
      });
      onSuccess();
    } catch (err) {
      setError(err?.response?.data?.MESSAGE || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="reg-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>➕ Register New User</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="reg-modal-body">
          <div className="reg-field">
            <label>Full Name <span className="req">*</span></label>
            <input name="name" value={form.name} onChange={handleChange} placeholder="John Doe" autoFocus />
          </div>

          <div className="reg-field">
            <label>Email <span className="req">*</span></label>
            <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="john@example.com" />
          </div>

          <div className="reg-field">
            <label>Mobile Number</label>
            <PhoneInput
              countryCodes={countryCodes}
              dialCode={form.country_code}
              onDialCodeChange={(val) => setForm(prev => ({ ...prev, country_code: val }))}
              mobileNumber={form.mobile_number}
              onMobileNumberChange={(val) => { setForm(prev => ({ ...prev, mobile_number: val, whatsapp_enabled: val ? prev.whatsapp_enabled : false })); setError(""); }}
            />
          </div>

          <div className="reg-field reg-field-row">
            <label>
              <input
                type="checkbox"
                name="whatsapp_enabled"
                checked={form.whatsapp_enabled}
                onChange={handleChange}
                disabled={!form.mobile_number.trim()}
              />
              WhatsApp Enabled
            </label>
            {!form.mobile_number.trim() && (
              <span className="reg-hint">Enter mobile number to enable</span>
            )}
          </div>

          <div className="reg-field">
            <label>Time Zone</label>
            <select name="time_zone" value={form.time_zone} onChange={handleChange}>
              {TIMEZONES.map((tz) => <option key={tz} value={tz}>{tz}</option>)}
            </select>
          </div>

          {error && <div className="reg-error">{error}</div>}

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose} disabled={loading}>Cancel</button>
            <button type="submit" className="btn-register" disabled={loading}>
              {loading ? <span className="reg-spinner" /> : "Register User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterUserModal;
